import { jsPDF } from 'jspdf';
import converter from 'number-to-words';
import logo from '../../../icons/Cet_emblem.jpg';

const generateHostelFeeBillPDF = (feeData, studentData) => {
  try {
    // Initialize PDF
    const doc = new jsPDF();

    // Function to generate single bill copy
    const generateBillCopy = (startY, type) => {
      try {
        // Header
        doc.addFont('times', 'Times', 'normal');
        doc.setFont('Times');

        // Title section - reduced font sizes and spacing
        doc.addImage(logo, 'PNG', 20, startY + 2, 25, 25);
        
        doc.setFontSize(14);
        doc.text("HOSTEL OFFICE - COLLEGE OF ENGINEERING", 105, startY + 10, { align: "center" });
        doc.text("THIRUVANANTHAPURAM - 16", 105, startY + 16, { align: "center" });

        doc.setFontSize(11);
        doc.text("Ph: 0471- 2515689, e-mail Id warden@cet.ac.in", 105, startY + 22, { align: "center" });

        // Bill details - reduced spacing
        doc.line(20, startY + 25, 190, startY + 25);

        doc.setFontSize(10);
        const billNumber = `No. ${studentData?.receipt_no || 'HF-' + new Date().getTime()}`;
        const dateStr = new Date().toLocaleDateString();
        doc.text(billNumber, 20, startY + 32);
        doc.text(`Date: ${dateStr}`, 150, startY + 32);

        // Bill title
        doc.setFontSize(12);
        doc.setFont("Times", "bold");
        doc.text("HOSTEL ADMISSION FEE RECEIPT", 20, startY + 40);

        // Student details - reduced spacing
        doc.setFontSize(10);
        doc.setFont("Times", "bold");
        doc.text("Student Details:", 20, startY + 46);
        doc.setFont("Times", "normal");
        
        const admissionNo = `Admission No: ${studentData?.admission_no || ''}`;
        const studentName = `Name: ${studentData?.name || ''}`;
        const category = `Category: ${studentData?.scholarship_category || 'General'}`;
        
        doc.text(admissionNo, 20, startY + 52);
        doc.text(category, 150, startY + 52);
        doc.text(studentName, 20, startY + 58);

        // Table headers
        doc.line(20, startY + 62, 190, startY + 62);
        doc.text("Description", 25, startY + 66);
        doc.text("Amount", 165, startY + 66);
        doc.line(20, startY + 68, 190, startY + 68);

        // Fee items - reduced line spacing
        let currentY = startY + 73;
        let totalAmount = 0;

        feeData.forEach(fee => {
          doc.text(fee.fee_name, 25, currentY);
          doc.text(`Rs.${fee.value}/-`, 165, currentY);
          totalAmount += fee.value;
          currentY += 5; // Reduced line spacing
        });

        // Total
        doc.line(20, currentY + 2, 190, currentY + 2);
        doc.setFont("Times", "bold");
        doc.text("Total Amount", 25, currentY + 7);
        doc.text(`Rs.${totalAmount}/-`, 165, currentY + 7);

        // Amount in words
        doc.setFont("Times", "normal");
        doc.setFontSize(9);
        doc.text(`(Rupees ${converter.toWords(totalAmount)} only)`, 25, currentY + 12);

        // Footer
        doc.setFontSize(10);
        doc.text("Authorized Signatory", 150, currentY + 20);

        // Copy indicator
        doc.setFontSize(8);
        doc.text(type, 20, currentY + 20);
      } catch (error) {
        console.error('Error in generateBillCopy:', error);
        throw error;
      }
    };

    // Generate first copy
    generateBillCopy(0, "OFFICE COPY");

    // Add dividing line - moved up
    doc.setLineDash([2, 2]);
    doc.line(10, 148, 200, 148);
    doc.setFontSize(8);
    doc.text("Cut Here", 95, 150);
    doc.setLineDash([]);

    // Generate second copy - adjusted starting position
    generateBillCopy(148, "STUDENT COPY");

    return doc;
  } catch (error) {
    console.error('Error in generateHostelFeeBillPDF:', error);
    throw error;
  }
};

export const generateAndDownloadHostelFeeBill = async (feeData, studentData) => {
  try {
    if (!feeData || !studentData) {
      throw new Error('Fee data and student data are required');
    }

    const doc = generateHostelFeeBillPDF(feeData, studentData);

    // Generate filename
    const filename = `hostel_fee_receipt_${studentData.admission_no || 'unknown'}_${new Date().getTime()}.pdf`;

    doc.save(filename);
  } catch (error) {
    console.error('Error generating PDF:', error);
    throw error;
  }
};